import React, { Component } from "react";
import Grid from "material-ui/Grid";
import ReactTable from "react-table";
import Typography from "material-ui/Typography";
import checkboxHOC from "react-table/lib/hoc/selectTable";
import Input, { InputAdornment } from "material-ui/Input";
import { FormControl } from "material-ui/Form";
import SearchIcon from "material-ui-icons/Search";
import Fuse from "fuse.js";

import "./FilterTable.css";

const CheckboxTable = checkboxHOC(ReactTable);

class FilterTable extends Component {
  constructor(props) {
    super(props);
    let filterableColumns = [];
    this.props.columns.forEach(c => {
      if (c.filterable === true || c.filterable === undefined)
        filterableColumns.push(c.accessor);
    });
    this.state = {
      filterableColumns,
      filterValue: "",
      data: this.props.data
    };
  }

  componentDidUpdate = (prevProps, prevState, snapshot) => {
    if (prevProps !== this.props) {
      const filterValue = this.state.filterValue;
      this.setState({ data: this.filterData(filterValue) });
    }
  };

  onChangeFilter = e => {
    const filterValue = e.target.value;
    this.setState({ filterValue, data: this.filterData(filterValue) });
  };

  filterData = filterValue => {
    const filterableColumns = this.state.filterableColumns;
    let data = this.props.data;
    if (filterValue === "") {
      return data;
    }

    var options = {
      shouldSort: true,
      threshold: 0.3,
      location: 0,
      distance: 30,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      keys: filterableColumns
    };
    var fuse = new Fuse(data, options);
    var result = fuse.search(filterValue);
    return result;
  };

  toggleSelection = (key, shift, row) => {
    if (this.props.toggleSelection) this.props.toggleSelection(key, shift, row);
  };

  isSelected = key => {
    return this.props.isSelected ? this.props.isSelected(key) : false;
  };

  toggleAll = () => {
    if (this.props.toggleAll) this.props.toggleAll();
  };

  render() {
    const {
      checkable,
      selectType,
      lang,
      columns,
      defaultPageSize,
      tableHeader,
      filterable,
      showPagination,
      isAllSelected
    } = this.props;

    const { toggleSelection, toggleAll, isSelected } = this;

    const checkboxProps = {
      selectAll: isAllSelected,
      isSelected,
      toggleSelection,
      toggleAll,
      selectType
    };

    return (
      <React.Fragment>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          className="grid-item"
        >
          {filterable && (
            <Grid container>
              <Grid
                item
                xs={6}
                sm={6}
                md={6}
                lg={6}
                xl={6}
                className="grid-item"
              >
                <Typography
                  variant="headline"
                  align="left"
                  color="primary"
                  className="headline"
                >
                  {tableHeader}
                </Typography>
              </Grid>
              <Grid
                item
                xs={6}
                sm={6}
                md={6}
                lg={6}
                xl={6}
                className="grid-item"
              >
                <div className="filter">
                  <FormControl className="filter-box">
                    <Input
                      className="filter-box"
                      id="filter"
                      type="text"
                      onChange={this.onChangeFilter}
                      startAdornment={
                        <InputAdornment position="start">
                          <SearchIcon color="primary" />
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </div>
              </Grid>
            </Grid>
          )}

          {!filterable && (
            <Grid container>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                className="grid-item"
              >
                <Typography
                  variant="headline"
                  align="center"
                  color="primary"
                  className="headline"
                >
                  {tableHeader}
                </Typography>
              </Grid>
            </Grid>
          )}
        </Grid>

        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          className="grid-item"
        >
          {!checkable && (
            <ReactTable
              data={this.state.data}
              columns={columns}
              showPagination={showPagination}
              defaultPageSize={defaultPageSize}
              filterable={false}
              previousText={lang.Anterior}
              nextText={lang.Siguiente}
              loadingText={`${lang.Cargando}...`}
              noDataText={lang.NoSeEncontraronResultados}
              pageText={lang.Pagina}
              ofText={lang.De}
              rowsText={lang.Resultados}
              className="-striped -highlight borderless"
            />
          )}
          {checkable && (
            <CheckboxTable
              ref={r => (this.checkboxTable = r)}
              data={this.state.data}
              columns={columns}
              showPagination={showPagination}
              defaultPageSize={defaultPageSize}
              filterable={false}
              previousText={lang.Anterior}
              nextText={lang.Siguiente}
              loadingText={`${lang.Cargando}...`}
              noDataText={lang.NoSeEncontraronResultados}
              pageText={lang.Pagina}
              ofText={lang.De}
              rowsText={lang.Resultados}
              className="-striped -highlight borderless"
              getTrProps={(state, rowInfo, column, instance) => {
                let selected = false;
                if (rowInfo !== undefined) {
                  selected = checkboxProps.isSelected(rowInfo.original._id);
                }
                return {
                  style: {
                    backgroundColor: selected ? "lightblue" : ""
                  },
                  onClick: (e, handleOriginal) => {
                    checkboxProps.toggleSelection(rowInfo.original._id);

                    if (handleOriginal) {
                      handleOriginal();
                    }
                  }
                };
              }}
              {...checkboxProps}
            />
          )}
        </Grid>
      </React.Fragment>
    );
  }
}

export default FilterTable;



// WEBPACK FOOTER //
// ./src/components/FilterTable/FilterTable.js